import { SvgIcon, type SvgIconProps } from "@mui/material";

import spaceFloridaOrbitLogoUrl from "./SpaceFloridaOrbitLogo.svg";
import spaceFloridaWordmarkUrl from "./SpaceFloridaWordmark.png";

/** Nav-bar style Space Florida ORBIT logo (SVG asset). */
export function SpaceFloridaOrbitLogo({ ...props }: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 400 150" {...props} sx={[{ height: "unset", width: "unset" }]}>
      <image height="54" href={spaceFloridaWordmarkUrl} preserveAspectRatio="xMidYMid meet" width="290" x="55" y="8" />
      <image height="150" href={spaceFloridaOrbitLogoUrl} preserveAspectRatio="xMidYMid meet" width="400" />
    </SvgIcon>
  );
}
